export const Logo = ({ dark = false, className = "h-10" }) => (
  <img
    src="/assets/fellesviar-logo-trimmed.png"
    alt="FellesViar Capsule"
    data-testid="brand-logo"
    className={`${className} w-auto object-contain ${
      dark ? "rounded-lg bg-white px-3 py-1.5" : ""
    }`}
  />
);

export default Logo;
